import template from './employee_history_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class EmployeeHistoryLogHelpViewModel
{
    constructor(dialog)
    {
        this.dialog = dialog;
    };

    close()
    {
        this.dialog.close();
    }
};

class EmployeeHistoryLogHelpPage
{
    constructor(bindings)
    {
        this.viewModel = new EmployeeHistoryLogHelpViewModel(this);
        this.bindings = bindings;
        const tr = Utils.get_translator('default');
    };

    init()
    {
        Utils.refresh_data_visible_roles();
    }
};

export default {
    name: 'EmployeeHistoryLogHelp',
    dialog_class: EmployeeHistoryLogHelpPage,
    template: template,
    template_filename: 'translation/dialogs/employee_history_help',
    provider: 'ps'
};